import moment from 'moment';

export default {
  dateFormat(date = new Date(), formatter = 'YYYY-MM-DD') {
    return moment(date).format(formatter);
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js